module.exports = __webpack_public_path__ + "static/media/iPhone.6bc55718.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iPhone.png
// module id = 2320
// module chunks = 0